import React from 'react';
import { Navigate } from 'react-router';
import Base from '../../Base';
import SelectAsync from 'react-select/async';
import { NavLink } from 'react-router-dom';
import SendSms from "../../Crm/SendSms";

export default class CurriculumPersons extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'curriculumperson',
            data: null,
            loading: true,
            configName: 'curriculumperson_grid',
            moduleName: 'فراگیران',
            filters: {
                curriculumId: props.CurriculumId
            },
            person: null
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    setPerson(e) {
        this.state.person = e;
    }
    save(e) {
        e.preventDefault();
        if (this.isNull(this.state.person)) {
            this.showErorrMessage("لطفا شخصی را انتخاب نمایید");
            return;
        }

        this.httpPost("api/v1/curriculumperson/save", {
            id: this.getDefaultGuid(),
            curriculumId: this.state.filters.curriculumId,
            personId: this.state.person.value
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.person = null;
                    this.showSuccessMessage("اطلاعات با موفقیت ثبت شد");
                    this.refreshData();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    sendSms() {
        this.removeKeyDown();
        this.showComponents({
            component: <SendSms Mobiles={this.getGridColumnValues("personMobile")} Caller={this} />
        });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "personName", caption: "نام فراگیر", show: true },
                { field: "personMobile", caption: "موبایل فراگیر", show: true },
                { field: "dateString", caption: "تاریخ ثبت نام", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'personName' && f.show) t.push({
                field: f.field, headerName: f.caption, cellRenderer: (props) => {
                    return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.personName}</a>
                }
            });
            if (f.field == 'personMobile' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return [
            <div className="modal-backdrop fade show" style={{ "zIndex": this.getModalOverZIndex() }}></div>,
            <div className="modal fad modal-full-96 show opened" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="modal-title">فراگیران</span>
                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={e => this.closeMe()}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="card-inner-group mb-4">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-success">
                                        <div className="col-lg-12">
                                            <div className="card h-100">
                                                <div className="card-inner">
                                                    <div className="row g-4">
                                                        <div className="col-lg-10">
                                                            <label className="form-label">افزودن فراگیر جدید</label>
                                                            <SelectAsync
                                                                defaultValue={this.state.person}
                                                                isMulti={false}
                                                                placeholder="انتخاب کنید"
                                                                defaultOptions
                                                                loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
                                                                onChange={e => this.setPerson(e)}
                                                            />
                                                        </div>
                                                        <div className="col-lg-2" style={{ "display": "flex", "align-items": "flex-end", "place-content": "end" }}>
                                                            <button type="submit" onClick={e => this.save(e)} className="btn btn-lg btn-primary">ثبت فراگیر</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block">
                                <div className="card card-bordered card-stretch">
                                    {/*<div style={{ "padding": "2px 5px" }}>*/}
                                    {/*    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onPrint('فهرست فراگیران')} title="چاپ">*/}
                                    {/*        <em style={{ "fontSize": "1.8rem" }} className="fa fa-print text-primary" ></em>*/}
                                    {/*    </a>*/}
                                    {/*    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onPdf('فهرست فراگیران')} title="پی دی اف">*/}
                                    {/*        <em style={{ "fontSize": "1.8rem" }} className="fa fa-file-pdf text-danger"></em>*/}
                                    {/*    </a>*/}
                                    {/*    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onExcel('فهرست فراگیران')} title="اکسل">*/}
                                    {/*        <em style={{ "fontSize": "1.8rem" }} className="fa fa-file-excel text-success"></em>*/}
                                    {/*    </a>*/}
                                    {/*    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onRemove()} title="حذف">*/}
                                    {/*        <i style={{ "fontSize": "1.8rem" }} className="mir-trash text-danger"></i>*/}
                                    {/*    </a>*/}
                                    {/*</div>*/}
                                    {this.getToolBar(false, {
                                        add: false, print: true, pdf: true, excell: true, remove: false,
                                        otherFilters: [
                                            //<a onClick={e => this.sendSms()} className="hand btn btn-warning"><em className="fa fa-mobile"></em><span>ارسال پیامک</span></a>
                                        ]
                                    })}

                                    {this.renderAgGrid({
                                        columnDefs: this.getColumns()
                                    })}
                                    <div className="mobile-table">
                                        {this.state.data.records.map((record, index) =>
                                            <div className="card p-3 row mt-2 flex justify-content-between">
                                                {this.getDefaultConfig().fields.map((m, index) =>
                                                    <div>
                                                        <b>{m.caption} :</b>
                                                        {index === 0 ?
                                                            <span>
                                                                <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                                    {record[m.field]}
                                                                </a>
                                                            </span> :
                                                            record[m.field]
                                                        }
                                                    </div>
                                                )}
                                                <div>
                                                    <div className="item-actions">
                                                        <a className="item-delete-btn" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                            <i className="mir-trash text-danger"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer row">
                            <div className="col-lg-2">
                                <button type="button" className="btn btn-secendry w-100" onClick={e => this.closeMe()}>انصراف</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ]
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}